
 
export const FETCH_PAYMENT_PURPOSES_REQUEST = 'paymentPurposes/FETCH_PAYMENT_PURPOSES_REQUEST';
export const FETCH_PAYMENT_PURPOSES_SUCCESS = 'paymentPurposes/FETCH_PAYMENT_PURPOSES_SUCCESS';
export const FETCH_PAYMENT_PURPOSES_FAILURE = 'paymentPurposes/FETCH_PAYMENT_PURPOSES_FAILURE';

 
export const FETCH_PAYMENT_PURPOSE_REQUEST = 'paymentPurposes/FETCH_PAYMENT_PURPOSE_REQUEST';
export const FETCH_PAYMENT_PURPOSE_SUCCESS = 'paymentPurposes/FETCH_PAYMENT_PURPOSE_SUCCESS';
export const FETCH_PAYMENT_PURPOSE_FAILURE = 'paymentPurposes/FETCH_PAYMENT_PURPOSE_FAILURE';

 
export const DELETE_PAYMENT_PURPOSE_REQUEST = 'paymentPurposes/DELETE_PAYMENT_PURPOSE_REQUEST';
export const DELETE_PAYMENT_PURPOSE_SUCCESS = 'paymentPurposes/DELETE_PAYMENT_PURPOSE_SUCCESS';
export const DELETE_PAYMENT_PURPOSE_FAILURE = 'paymentPurposes/DELETE_PAYMENT_PURPOSE_FAILURE';

 
export const CREATE_PAYMENT_PURPOSE_REQUEST = 'paymentPurposes/CREATE_PAYMENT_PURPOSE_REQUEST';
export const CREATE_PAYMENT_PURPOSE_SUCCESS = 'paymentPurposes/CREATE_PAYMENT_PURPOSE_SUCCESS';
export const CREATE_PAYMENT_PURPOSE_FAILURE = 'paymentPurposes/CREATE_PAYMENT_PURPOSE_FAILURE';

 
export const UPDATE_PAYMENT_PURPOSE_REQUEST = 'paymentPurposes/UPDATE_PAYMENT_PURPOSE_REQUEST';
export const UPDATE_PAYMENT_PURPOSE_SUCCESS = 'paymentPurposes/UPDATE_PAYMENT_PURPOSE_SUCCESS';
export const UPDATE_PAYMENT_PURPOSE_FAILURE = 'paymentPurposes/UPDATE_PAYMENT_PURPOSE_FAILURE';


export const UPDATE_FIELD = 'paymentPurposes/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'paymentPurposes/SET_DEFAULT_DATA';
